<template>
  <ChecklistBlockBase :buttonsData="editorMetadata.buttonsData" :buttonsPreset="'copy'"  @commonAction="(action) => $emit('commonAction', action)">
    <WhiteIQOS noOverflow bodyClass="checklist-block-iqos-body">
      <template #title>
        <BaseIcon size="sm3" icon="paperclip" /> {{ $t('checklist_blocks.file.title')}}
      </template>

      <div class="checklist-block-iqos-body-block">
        <BaseTextInput v-model="block.title" @blur="$emit('commonAction', 'update')" size="md" :placeholder="$t('checklist_blocks.title_ph')" />
      </div>

      <template #footer>
        <BlockAssignOption @assigned="$emit('commonAction', 'update')" :block="block" :optionsBlocks="editorMetadata.optionsBlocksAbove"/>
        <BaseDivider color="border-base-secondary"/>
        <CommonBlockSettings @update="$emit('commonAction', 'update')" :block="block"/>
      </template>
    </WhiteIQOS>
  </ChecklistBlockBase>
</template>

<script>
import ChecklistBlockBase from "./ChecklistBlockBase.vue";
import BlockAssignOption from "../BlockAssignOption.vue"

import CommonBlockSettings from "../CommonBlockSettings.vue"

export default {
  props: {
    block: Object,
    editorMetadata: Object
  },
  components: {
    ChecklistBlockBase,
    BlockAssignOption,
    CommonBlockSettings
  },
};
</script>

<style>
</style>